import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setFeatureConfig } from "@/redux/slices/featureFlagSlice";
import useGetEnvironmentFeature from "@/utils/feature-flag/environment";

interface FeatureInitializerProps {
  children: React.ReactNode;
}

const FeatureInitializer: React.FC<FeatureInitializerProps> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const config = useGetEnvironmentFeature();

  useEffect(() => {
    dispatch(setFeatureConfig(config));
  }, [config]);

  return <>{children}</>;
};

export default FeatureInitializer;
